<script>
import { createEventDispatcher } from 'svelte'
const dispatch = createEventDispatcher()

export let cocktail
export let delay = 0
</script>

<style>
.cocktail{ text-align:center; cursor:pointer; }
.cocktail h2{ color:white; opacity:1; }
.cocktail img{ height:320px; }
</style>

<div class="cocktail" data-aos="zoom-in" data-aos-delay={delay} on:click={()=>dispatch('popup', cocktail)}>
    <img src="./res/cocktails/{cocktail.img}.png" alt={cocktail.title} />
    <h2>{ cocktail.title }</h2>
</div>